type StandardError = {
  message: string;
  status: number;
  details: any;
};

const apiErrorHandler = (error: any): StandardError => {
  if (error.response) {
    const status = error.response.status;

    let message = 'An unexpected error occurred.';
    let details = error.response.data?.details || null;

    switch (status) {
      case 400:
        message =
          error.response.data.message ||
          'Invalid request. Please check your input.';
        details = error.re;
        break;
      case 401:
        message = "You're not authorized. Please log in.";
        break;
      case 403:
        message = "You don't have permission to do this.";
        break;
      case 404:
        message = 'The resource was not found.';
        break;
      case 422:
        message = 'Validation failed.';
        break;
      case 500:
        message = 'Internal server error. Please try again later.';
        break;
      default:
        message = error.response?.data?.message || 'Something went wrong.';
        break;
    }

    return {
      message,
      status,
      details,
    };
  } else if (error.request) {
    return {
      message:
        'No response from server. Please check your internet connection.',
      status: 0,
      details: null,
    };
  } else {
    return {
      message: 'An unknown error occurred.',
      status: -1,
      details: null,
    };
  }
};

export default apiErrorHandler;
